import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "rb-btn__goo",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "rb-btn__label" }

type Variant = 'cult'
type Surface = 'fancy' | 'textured'
type Size = 'md' | 'lg'

interface Props {
  variant?: Variant
  surface?: Surface
  size?: Size
  href?: string
  to?: string
  target?: string
  rel?: string
  type?: 'button' | 'submit' | 'reset'
}

interface Blob {
  style: Record<string, string>
}


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'MRainbowButton',
  props: {
    variant: { default: 'cult' },
    surface: { default: 'textured' },
    size: { default: 'md' },
    href: {},
    to: {},
    target: {},
    rel: {},
    type: { default: 'button' }
  },
  setup(__props: any) {



const props = __props

const attrs = useAttrs()
const NuxtLink = resolveComponent('NuxtLink')

const component = computed(() => {
  if (props.to)
    return NuxtLink
  if (props.href)
    return 'a'
  return 'button'
})

const componentAttrs = computed(() => {
  const base = {
    ...attrs,
    class: [
      'rb-btn',
      `rb-btn--${props.variant}`,
      `rb-btn--surface-${props.surface}`,
      `rb-btn--size-${props.size}`,
      attrs.class,
    ],
  }

  if (props.to)
    return { ...base, to: props.to }

  if (props.href) {
    return {
      ...base,
      href: props.href,
      target: props.target,
      rel: props.rel ?? (props.target === '_blank' ? 'noopener noreferrer' : undefined),
    }
  }

  return { ...base, type: props.type }
})

const blobs = computed<Blob[]>(() => {
  return Array.from({ length: 5 }, (_, i) => ({
    style: {
      'left': `${((i + 0.5) / 5) * 100}%`,
      'animationDelay': `${i * 0.42}s`,
      '--size': `${[12, 16, 11, 14, 13][i]}px`,
    },
  }))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), _normalizeProps(_guardReactiveProps(_unref(componentAttrs))), {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("svg", {
        width: "0",
        height: "0",
        class: "rb-btn__filter",
        "aria-hidden": "true"
      }, [
        _createElementVNode("defs", null, [
          _createElementVNode("filter", { id: "rb-goo" }, [
            _createElementVNode("feGaussianBlur", {
              in: "SourceGraphic",
              stdDeviation: "6"
            }),
            _createElementVNode("feColorMatrix", {
              type: "matrix",
              values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
            })
          ])
        ])
      ], -1)),
      _createElementVNode("span", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "rb-btn__goo-base" }, null, -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blobs), (blob, i) => {
          return (_openBlock(), _createElementBlock("span", {
            key: i,
            class: "rb-btn__blob",
            style: _normalizeStyle(blob.style)
          }, null, 4))
        }), 128))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "rb-btn__surface",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 16))
}
}

})